import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
  LayoutDashboard,
  Building2,
  HeartPulse,
  IndianRupee,
  Users,
  Settings,
  BookText,
  ClipboardCheck,
  Wallet,
} from "lucide-react";
import { DashboardShell, type NavItem } from "@/components/dashboard-shell";

const items: NavItem[] = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/applications", label: "Onboarding", icon: ClipboardCheck },
  { to: "/admin/institutions", label: "Institutions", icon: Building2 },
  { to: "/admin/causes", label: "Causes", icon: HeartPulse },
  { to: "/admin/donations", label: "Donations", icon: IndianRupee },
  { to: "/admin/payouts", label: "Payouts", icon: Wallet },
  { to: "/admin/donors", label: "Donors", icon: Users },
  { to: "/admin/stories", label: "Stories", icon: BookText },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export const Route = createFileRoute("/admin")({
  head: () => ({ meta: [{ title: "Super Admin — Animal Seva" }] }),
  component: () => (
    <DashboardShell role="Super Admin" orgName="Manavta" color="var(--saffron-deep)" items={items}>
      <Outlet />
    </DashboardShell>
  ),
});
